import React, { useState } from 'react';

import ModalFilter from 'components/ModalFilter';
import QuotesCard from '../QuotesCard';
import ButtonPDF from '../ButtonPDF';
import ReportTask from '../ReportTask';

import {
  Description, TextCounter, List, Footer, NoContent,
} from './styles';

const DownloadReportModal = ({
  isOpen, setModalVisible, taskDetail, company,
}) => {
  const [selectedQuotes, setSelectedQuotes] = useState([]);
  const [msgError, setMsgError] = useState(null);
  const [error, setError] = useState(null);
  const quotes = taskDetail.quotes.filter(q => !!q.price);
  const processPDF = useState(false);
  const maxItems = 4;

  const close = () => {
    setModalVisible(false);
  };

  const clearError = () => {
    if (msgError !== null) {
      setError(null);
      setMsgError(null);
    }
  };

  const handleListSelected = (value) => {
    clearError();
    processPDF[1](false);
    selectedQuotes.indexOf(value) !== -1
      ? setSelectedQuotes(selectedQuotes.filter(item => item !== value))
      : setSelectedQuotes(selectedQuotes.concat(value));
  };

  const validationCheck = () => {
    if (selectedQuotes.length > 0 && selectedQuotes.length < 5) { setError(null); return true; }

    if (selectedQuotes.length > maxItems) { setMsgError(`Você pode selecionar no máximo ${maxItems} orçamentos.`); } else {
      setMsgError('Você precisa selecionar pelo menos um orçamento.');
      setError(true);
    }

    return false;
  };

  return (
    <ModalFilter padding="30px 30px 40px 40px" isOpen={isOpen} textTransform="none" title="Resumo dos orçamentos" toggle={close}>

      <Description>
        Esse documento contém uma descrição detalhada do serviço a ser realizado,
        para lhe auxiliar na decisão de contratação.
      </Description>
      {<TextCounter>{`Você selecionou ${selectedQuotes.length} de ${quotes.length} prestadores`}</TextCounter>}

      {quotes.length > 0
        ? (
          <List>
            {quotes.map(
              (task, index) => (
                <QuotesCard
                  task={task}
                  error={error}
                  handleListSelected={() => handleListSelected(index)}
                />
              ),
            )}
          </List>
        )
        : <NoContent style={{}}>Não existem orçamentos a serem apresentados!</NoContent>
      }

      <Footer>
        <ButtonPDF
          msgError={msgError}
          validation={validationCheck}
          renderControl={processPDF}
          fileName={`Resumo-${taskDetail.service_name}.pdf`}
          file={(
            <ReportTask
              taskDetail={taskDetail}
              company={company}
              quotes={quotes.filter(
                (item, index) => selectedQuotes.includes(index),
              )}
            />
          )}
        />
      </Footer>

    </ModalFilter>
  );
};

export default DownloadReportModal;
